/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_MarginsInputs */

const en_nav_margins = /** @type {(inputs: Nav_MarginsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Margins`)
};

/**
* | output |
* | --- |
* | "Margins" |
*
* @param {Nav_MarginsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_margins = /** @type {((inputs?: Nav_MarginsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_MarginsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_margins(inputs)
});